import { calculateDistance } from '@utils/helpers';

export const EXPLORE_SORT_STORAGE_KEY = 'playfynd_explore_sort_v2';

export const SORT_HAPPENING_SOON = 'happeningSoon';
export const SORT_NEAREST = 'nearest';
export const SORT_RECENT = 'recent';

export const DEFAULT_EXPLORE_SORT = SORT_RECENT;

const VALID_SORTS = new Set([SORT_HAPPENING_SOON, SORT_NEAREST, SORT_RECENT]);

export const EXPLORE_SORT_OPTIONS = [
  { id: SORT_RECENT, label: 'Recently Added', hint: 'Newest posts first' },
  { id: SORT_NEAREST, label: 'Nearby Vibes', hint: 'Closest to your location' },
  { id: SORT_HAPPENING_SOON, label: 'Happening Soon', hint: 'Start time · earliest first' },
];

function activityDistanceKm(activity, userLatLng) {
  if (userLatLng?.lat == null || userLatLng?.lng == null) return Number.POSITIVE_INFINITY;
  const c = activity?.location?.coordinates;
  if (!Array.isArray(c) || c.length !== 2) return Number.POSITIVE_INFINITY;
  return calculateDistance(userLatLng.lat, userLatLng.lng, c[1], c[0]);
}

/** Client-side sort for Explore lists (upcoming and past handled separately by caller). */
export function sortExploreActivities(activities, sortKey, userLatLng) {
  if (!Array.isArray(activities) || activities.length < 2) return [...(activities || [])];

  const list = [...activities];
  const key = VALID_SORTS.has(sortKey) ? sortKey : DEFAULT_EXPLORE_SORT;

  if (key === SORT_NEAREST) {
    list.sort((a, b) => {
      const da = activityDistanceKm(a, userLatLng);
      const db = activityDistanceKm(b, userLatLng);
      if (da !== db) return da - db;
      return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
    });
    return list;
  }

  if (key === SORT_RECENT) {
    list.sort((a, b) => {
      const ta = new Date(a.createdAt || a.updatedAt || 0).getTime();
      const tb = new Date(b.createdAt || b.updatedAt || 0).getTime();
      if (tb !== ta) return tb - ta;
      return new Date(a.dateTime).getTime() - new Date(b.dateTime).getTime();
    });
    return list;
  }

  list.sort((a, b) => {
    const da = new Date(a.dateTime).getTime();
    const db = new Date(b.dateTime).getTime();
    if (da !== db) return da - db;
    const ca = activityDistanceKm(a, userLatLng);
    const cb = activityDistanceKm(b, userLatLng);
    if (ca !== cb) return ca - cb;
    return String(a._id).localeCompare(String(b._id));
  });
  return list;
}

export function loadPersistedExploreSort() {
  if (typeof sessionStorage === 'undefined') return DEFAULT_EXPLORE_SORT;
  try {
    const raw = sessionStorage.getItem(EXPLORE_SORT_STORAGE_KEY);
    if (!raw) return DEFAULT_EXPLORE_SORT;
    const id = JSON.parse(raw);
    return typeof id === 'string' && VALID_SORTS.has(id) ? id : DEFAULT_EXPLORE_SORT;
  } catch {
    return DEFAULT_EXPLORE_SORT;
  }
}

export function persistExploreSort(sortKey) {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(EXPLORE_SORT_STORAGE_KEY, JSON.stringify(sortKey));
  } catch {
    /* ignore */
  }
}
